import React from "react";
import { Link } from "react-router-dom";
import {  Modal } from 'antd';
import { useMediaQuery } from "react-responsive";

const DeleteModal = (props) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <>
      {/* Delete Performance Indicator Modal */}
      {/* <div className="modal custom-modal fade" id="delete" role="dialog">
        <div className="modal-dialog modal-dialog-centered"> */}
        <Modal
              // title="Add Your Details"
              style={{ top: 100 }}
              open={props.deleteModal}
              width={isMobile? "100%" : "40%"}
              footer={[]}
              // onOk={() => setModal1Open(false)}
              onCancel={() => {
                props.setDeleteModal(false)}}
                afterClose={() => {
                  // Move focus safely out of modal
                  // buttonRef.current?.focus();
                }}
                mask={false}
            >
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{props.Name}</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-md-6 col-sm-12 mb-1">
                    <Link onClick={props.deleteHandler} className="btn btn-primary continue-btn">
                      Delete
                    </Link>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <Link
                      to="#"
                      // data-bs-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                      onClick={() => {
                        props.setDeleteModal(false)}}
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Modal>
        {/* </div>
      </div> */}
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default DeleteModal;
